module.exports = __webpack_public_path__ + "static/media/map-marker-white.d68f0fa9.svg";